// extracted by mini-css-extract-plugin
export default {"root":"Tail_root__iLmq6","up":"Tail_up__pcNon","tail":"Tail_tail__7Fy7B"};